/**
 * Organization 도메인 Zod 스키마
 */
import { ORGANIZATION_TYPE } from '../constants.js';
import { idSchema, pageSchema } from './common.js';
import { z } from 'zod';
/**
 * 조직 목록 조회 입력 스키마
 */
export const listOrganizationsInputSchema = z.object({
    churchId: idSchema,
    page: pageSchema,
});
/**
 * 조직 생성 입력 스키마
 */
export const createOrganizationInputSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    churchId: idSchema,
    type: z.enum([ORGANIZATION_TYPE.ELEMENTARY, ORGANIZATION_TYPE.MIDDLE_HIGH, ORGANIZATION_TYPE.YOUNG_ADULT]),
});
/**
 * 조직 합류 요청 입력 스키마
 */
export const requestJoinInputSchema = z.object({
    organizationId: idSchema,
});
/**
 * 합류 요청 승인 입력 스키마
 */
export const approveJoinInputSchema = z.object({
    joinRequestId: idSchema,
});
/**
 * 합류 요청 거부 입력 스키마
 */
export const rejectJoinInputSchema = z.object({
    joinRequestId: idSchema,
});
/**
 * 관리자 양도 입력 스키마
 */
export const transferAdminInputSchema = z.object({
    targetAccountId: idSchema,
});
